module.exports = __webpack_public_path__ + "static/media/undraw_login.dfa03c58.svg";